namespace GeniuzPOS.Inventory {
    export interface IcStockReturnInForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: SOLookupcustom;
        RefDocNo2: Serenity.StringEditor;
        WhsId: Serenity.LookupEditor;
        StockFrom: Serenity.LookupEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        CheckQty: Serenity.StringEditor;
        ReturnInDtList: IcStockReturnInDtEditor;
    }

    export class IcStockReturnInForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockReturnIn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockReturnInForm.init)  {
                IcStockReturnInForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = SOLookupcustom;
                var w3 = s.LookupEditor;
                var w4 = s.EnumEditor;
                var w5 = s.TextAreaEditor;
                var w6 = IcStockReturnInDtEditor;

                Q.initFormType(IcStockReturnInForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w2,
                    'RefDocNo2', w0,
                    'WhsId', w3,
                    'StockFrom', w3,
                    'PostFg', w4,
                    'CancelFg', w4,
                    'Remark', w5,
                    'CheckQty', w0,
                    'ReturnInDtList', w6
                ]);
            }
        }
    }
}
